<template>
  <div class="observa4-results-table-print">
    <div  v-for="(page, i) in displayContent"
          class="observa4-results-print-page"
          :key="`page-${i}`">
      <div class="header-section" v-if="page.header">
        <print-header
            :year="year"
            :viewType="viewType"
            :counts="displayCounts"
            :subTitle="subTitle"
            :complianceLadder="complianceLadder">
        </print-header>
        <br>
      </div>
      <o4-result-table
          :sheetFilter="sheetFilter"
          :summary="page.sections"
          :showRatio="true">
      </o4-result-table>
    </div>
  </div>
</template>
<script>
import modules from '@/sui/data/modules'
import observa4ResultTable from '@/sui/components/results/observa4ResultTable.vue'
import printHeader from '@/sui/components/results/observa4PrintHeader'

export default {
  name: 'print-o4-result-table-view',

  props: {
    subTitle: {
      type: String,
      required: true
    },

    data: {
      type: Object,
      required: true
    },

    counts: {
      type: Object,
      required: true
    },

    complianceLadder: {
      type: Object,
      required: true
    },

    viewType: {
      type: String,
      required: true
    },

    year: {
      type: Number,
      required: true
    }

  },

  computed: {
    sheetFilter: function () {
      return this.data.sheetFilter
    },

    displayCounts: function () {
      const values = this.counts.values
      if (values == null) {
        return null
      }

      const formatter = modules.get(this.year).observa4.format.obsManagment
      const filteredSheetCount = {}
      let total = 0
      for (let i in values) {
        const sheet = formatter(parseInt(i)).toLowerCase()
        if (this.sheetFilter[sheet]) {
          const v = values[i]
          filteredSheetCount[i] = v
          total += v
        }
      }

      return {
        type: this.counts.type,
        total: total,
        values: filteredSheetCount
      }
    },

    displayContent: function () {
      const data = this.data.summary
      const result = []
      if (data == null) {
        return result
      }

      const linesPerPage = 11
      let page = {
        header: true,
        sections: []
      }

      function startNewPage (l) {
        result.push(page)
        page = {
          header: false,
          sections: []
        }
        remainingLines = linesPerPage - l
      }

      let remainingLines = linesPerPage - 4
      for (let i = 0; i < data.length; i++) {
        const category = data[i]
        const categoryLinesCount = category.lines.length
        remainingLines -= categoryLinesCount

        if (remainingLines <= 0) {
          startNewPage(categoryLinesCount)
        }
        page.sections.push(category)
      }

      startNewPage()
      return result
    }
  },

  components: {
    'print-header': printHeader,
    'o4-result-table': observa4ResultTable
  }
}

</script>
<style scoped>

</style>
